<div class="modal">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="title">
    <mat-icon class="back" (click)="gotoChoiceModal()">arrow_back_ios</mat-icon
    >选择您的订单
  </div>
  <div class="detail" mat-dialog-content>
    <div
      class="seat"
      *ngFor="let item of seats"
      (click)="openPlatformModal(item)"
    >
      <div class="part1">
        <app-image [fileid]="item.bus.platform.icon" [radius]="8"></app-image>
      </div>
      <div class="part2">
        <span>{{ item.bus.platform.name }}</span>
        <span>{{ item.bus.bus_type?.name }}</span>
      </div>
      <div class="part3">
        <span>
          <ng-container
            *ngIf="
              item.bus.bus_account &&
              ![
                'ChatGPT镜像版',
                '爆米花',
                'Midjourney镜像版',
                'Grok镜像版'
              ].includes(item.bus.platform.name)
            "
            >{{
              item.status !== "Disabled"
                ? item.bus.bus_account.username
                : "车票已禁用，请联系客服处理"
            }}
          </ng-container>
        </span>
        <span class="time"
          ><app-datetime [text]="item.ended_time"></app-datetime
        ></span>
      </div>
    </div>
    <mat-spinner *ngIf="loading" [diameter]="60"></mat-spinner>
    <div class="tip" *ngIf="hasMore" (click)="findMore()">点击加载更多</div>
  </div>
</div>
